import React from "react";
import { View, StyleSheet, ScrollView, useWindowDimensions } from "react-native";
import CustomText from "../../common/general/CustomText/CustomText";
import useResponsiveScreen from "../../../hooks/useResponsiveScreen";
import LearningGoalsContainer, { Objective } from "../../../containers/companion/LearningGoalsContainer";

const ProgressLightMenu = ({ objectivesData = [] }: { objectivesData?: Objective[] }) => {
  const { isMedium } = useResponsiveScreen();
  const { height: windowHeight } = useWindowDimensions();
  const containerMaxHeight = Math.max(windowHeight - 120, 0);

  return (
    <View
      role="menu"
      style={[
        styles.containerBase,
        isMedium ? styles.containerDesktop : styles.containerMobile,
        { maxHeight: containerMaxHeight },
      ]}>
      <ScrollView
        showsVerticalScrollIndicator={true}
        style={styles.mainScrollView}
        contentContainerStyle={styles.scrollContentContainer}
        tabIndex={0}>
        {objectivesData.length === 0 ? (
          <View style={styles.view}>
            <CustomText
              useTranslationText={false}
              styleType="dark"
              text="Initializing Experience..."
              size="."
              textType="text"
              weight="bold"
              style={styles.emptyStateText}
            />
          </View>
        ) : (
          <View style={styles.trackerContainer}>
            <LearningGoalsContainer objectives={objectivesData} />
          </View>
        )}
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  mainScrollView: {
    flexGrow: 1,
    width: "100%",
  },
  scrollContentContainer: {
    flexGrow: 1,
    paddingBottom: 100,
  },
  trackerContainer: {
    width: "100%",
  },
  containerBase: {
    flex: 1,
    alignSelf: "flex-start",
    overflow: "hidden",
    width: 270,
    paddingTop: 32,
    paddingHorizontal: 8,
  },
  containerDesktop: {
    borderRadius: 20,
  },
  containerMobile: {
    top: 0,
    left: 0,
    borderRadius: 0,
    height: "100%",
  },
  view: {
    paddingHorizontal: 8,
    justifyContent: "flex-start",
    paddingBottom: 20,
  },
  emptyStateText: {
    textAlign: "left",
  },
});

export default ProgressLightMenu;
